module.exports = __webpack_public_path__ + "static/media/122.c25ba7f4.png";